<div class="app-wrapper">
  <div class="app-content">
    <div class="main content-wrapper"
         *ngIf="translationsLoaded">
      <h2>{{ 'downloadAndroidApp' | translation:'mobileAppDownload' }}</h2>
      <ng-container *ngIf="!!androidVersion?.url">
        <a [href]="androidVersion!.safeUrl"
           download="{{androidVersion!.fileName}}"
           class="download-link"> {{androidVersion!.fileName}}</a>
      </ng-container>
      <ng-container *ngIf="!androidVersion?.url"><span>{{ 'androidAppLoadingError' | translation:'mobileAppDownload' }}</span></ng-container>
    </div>
  </div>
</div>